import Holidays, { HolidaysTypes } from 'date-holidays'
import momentTz from 'moment-timezone'

import { config } from '../config'

const holidaysOptions: HolidaysTypes.Options = { types: ['public', 'bank'] }
export const holidays = new Holidays(config.defaultTenantRegion, holidaysOptions)

const sunday = 0
const saturday = 6
export const weekendDays = [saturday, sunday]

export const localeNames = momentTz.tz.names()
